import { ConfigExibicaoCamposService } from './../../../content/pages/services/config-exibicao-campos.service';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatButton, MatDialog } from '@angular/material';
import { ConfiguracaoExibicaoCampos } from './configuracao-exibicao-campos.component';
import { ParametrosConfiguracaoExibicaoCamposModel } from './parametros-configuracao-exibicao-campos.model';

@Injectable()
export class DialogConfiguracaoExibicaoCamposService {

  listaOriginal;
  constructor(public dialog: MatDialog,
    public configExibicaoCamposService: ConfigExibicaoCamposService) { }

  openDialogConfiguracaoExibicaoCampos(listaOriginal, dadosLista, chaveTela, configExibicaoCampos): Subject<ConfiguracaoExibicaoCampos> {

    const retorno$ = new Subject<ConfiguracaoExibicaoCampos>();

    const posicao = {
      // left: `${btn._elementRef.nativeElement.offsetLeft - 410}px`,
      // top: `${btn._elementRef.nativeElement.offsetTop + 50}px`,
      left: '',
      top: '',
      right: '',
      bottom: '',
    };

    const parametros: ParametrosConfiguracaoExibicaoCamposModel = {
      listaOriginal,
      dadosLista,
      chaveTela
    };

    const options = {
      width: '500px',
      data: { configExibicaoCampos, parametros },
      hasBackdrop: true,
      disableClose: false,
      position: posicao
    };

    const dialogRefFiltros = this.dialog.open(ConfiguracaoExibicaoCampos, options);
    dialogRefFiltros.afterOpened().subscribe(() => {
      retorno$.next(dialogRefFiltros.componentInstance);
      console.log(this.listaOriginal);
    });

    return retorno$;
  }
}
